import React from "react";
import SectionTitle from "../components/SectionTitle";
import Card from "../components/Card";
import Reports from "./components/Reports";

const cardBody = [
  {
    title: "Credit Investigation",
    subtitle: "Integrity at Work",
    description: [
      "We put a premium on integrity in everything we do. From the resources we employ to the methods we implement in creating reports. All the data we gather are reliable and accurate. We also see to it that the delivery of reports is timely to address the urgency of your needs.",
    ],
  },
];

export default function Services() {
  return (
    <div className="d-flex w-100 align-items-center flex-column pt-4 pb-5 ps-4 pe-4 gap-3">
      <div className="text-center pb-4">
        <SectionTitle title="Services" />
        <div className="d-flex justify-content-center rounded bg-light pt-2 pb-2">
          <p className="text-center w-75 p-0 m-0 text-secondary fw-medium">
            “We provide accurate and complete information that fits the customer
            needs”
          </p>
        </div>
      </div>
      <Card body={cardBody} fitImage imageHeight="25rem" />
      <Reports />
    </div>
  );
}
